var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 30L60 20L45 35L30 20L20 30L35 45L20.0001 59.9999L30.0001 69.9998L45 55L59.9999 69.9999L69.9998 59.9999L54.9999 45L70 30Z",
    fill: "url(#paint0_angular_2484_6893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2484_6893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.4967 66.7212) rotate(-124.257) scale(13.4873 47.3372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0279551,
    stopColor: "#F23F62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168171,
    stopColor: "#953EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252895,
    stopColor: "#533DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306649,
    stopColor: "#293DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442146,
    stopColor: "#743EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96863,
    stopColor: "#293DED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8023316ee8a7f533c0c94855268a148a.svg";
export { ForwardRef as ReactComponent };